import { FC, ReactElement, useEffect } from 'react'
import * as cn from 'classnames'
import styles from 'components/features/rewards/rewardsPane/components/CryptoRewardsPaneSumPicker/CryptoRewardsPaneSumPicker.styl'
import { useFormContext } from 'react-hook-form'
import { useMutableRef } from 'hooks/useMutableRef'
import { LabeledInput } from 'components/atoms/inputs/LabeledInput/LabeledInput'


type CryptoRewardsPaneSumPickerProps = {
  name: string
  note?: string
  className?: string
}

export const CryptoRewardsPaneSumPicker: FC<CryptoRewardsPaneSumPickerProps> = ({
  name,
  note,
  className,
}): ReactElement => {
  const formContext = useFormContext()
  const formContextRef = useMutableRef(formContext)
  const nameRef = useMutableRef(name)

  useEffect(() => {
    // formContextRef.current?.trigger(nameRef.current)
  }, [formContextRef, nameRef])

  return (
    <LabeledInput
      name={ name }
      label='Amount'
      note={ note }
      className={ cn(styles.inputWrapper, className) }
      type='currency'
      autoComplete='off'
      units='USD'
      dynamicHeight={ false }
    />
  )
}
